import styles from './ButtonSpinner.module.css';

/**
 * ButtonSpinner Component
 *
 * Small inline loading spinner for buttons
 * Used to show loading state during async operations
 */
function ButtonSpinner() {
    return <div className={styles.spinner}></div>;
}

export default ButtonSpinner;
